import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { configuration, monitoring } from 'services';
import { routes } from 'static/routes';

const useNavigateToErrorPage = () => {
    const history = useHistory();

    return useCallback((reason: string) => {
        monitoring.emitEvent("Error", {
            Context: {reason}
        });
        history.replace(routes.Error);
    }, [history, configuration, monitoring, routes]);
};

export default useNavigateToErrorPage;
